import type { OrganizationFunnelInfo } from '@orus.eu/right-access-management'

import { useIsBrokerClient, type UseIsBrokerClientArgs } from './use-is-broker-client.ts'

type UseIsReferralFeatureAvailableResult = {
  isReferralFeatureAvailable: boolean
  isPending: boolean
  isBrokerClient: boolean
  isBrokerOwnedSubscription: boolean
}

export function useIsReferralFeatureAvailable(
  organization: OrganizationFunnelInfo | undefined,
  brokerClientArgs: UseIsBrokerClientArgs | null,
): UseIsReferralFeatureAvailableResult {
  const isBrokerOwnedSubscription = organization !== undefined && !organization.isManagedByOrus
  const skipBrokerClientCheck = brokerClientArgs === null
  const { isBrokerClient: resolvedIsBrokerClient, isPending: resolvedIsBrokerClientPending } = useIsBrokerClient(
    brokerClientArgs ?? { context: 'customer' },
  )
  const isBrokerClient = skipBrokerClientCheck ? false : resolvedIsBrokerClient
  const isPending = skipBrokerClientCheck ? false : resolvedIsBrokerClientPending
  const isReferralFeatureAvailable = !isPending && !isBrokerClient && !isBrokerOwnedSubscription

  return { isReferralFeatureAvailable, isPending, isBrokerClient, isBrokerOwnedSubscription }
}

export function resolveSubscriptionBrokerClientArgs({
  context,
  customerId,
}: {
  context: 'backoffice' | 'selfonboarding'
  customerId: string | undefined
}): UseIsBrokerClientArgs | null {
  switch (context) {
    case 'backoffice':
      if (customerId === undefined) {
        return null
      }
      return { context: 'backoffice', userId: customerId }
    case 'selfonboarding':
      return { context: 'customer' }
  }
}
